import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import React from "react";

const MoneyInput = ({ label, value, onChange }) => {
    const handleValueChange = (values) => {
        const { value } = values; // Valor numérico bruto
        onChange(value); // Atualiza o estado com o valor bruto
    };

    return (
        <NumericFormat
            customInput={TextField}
            label={label}
            fullWidth
            value={value}
            onValueChange={handleValueChange}
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            decimalScale={2}
            fixedDecimalScale
        />
    );
};

export default MoneyInput;
